import classNames from 'classnames';
import React from 'react';
import closeIcon from '../icons/non-prefilled/16x16/clear.svg';
import IconButton from './IconButton';
import styles from './Modal.module.scss';

interface ModalTitleProps {
  close?: () => void;
  children: React.ReactNode;
  noMargin?: boolean;
  subtitle?: React.ReactNode;
  small?: boolean;
}

export const ModalTitle = ({
  close,
  subtitle,
  children,
  noMargin = false,
  small = false,
}: ModalTitleProps) => (
  <div className={noMargin ? undefined : styles.titleMarginContainer}>
    <div className={styles.title}>
      {small ? <h3>{children}</h3> : <h2>{children}</h2>}
      {close && (
        <div className={styles.closeContainer}>
          <IconButton onClick={close} applyNegativeMargin aria-label="Close">
            {closeIcon}
          </IconButton>
        </div>
      )}
    </div>
    {!!subtitle && <div className={styles.subtitle}>{subtitle}</div>}
  </div>
);

interface ModalActionFooterProps {
  primary: React.ReactNode;
  secondary?: React.ReactNode;
  align?: 'stretch' | 'end';
}

export const ModalActionFooter = ({
  primary,
  secondary,
  align = 'stretch',
}: ModalActionFooterProps) => (
  <div
    className={classNames(styles.actionFooter, {
      [styles.alignEnd]: align === 'end',
    })}
  >
    <div className={styles.secondary}>{secondary}</div>
    <div className={styles.primary}>{primary}</div>
  </div>
);

interface ModalProps {
  children: React.ReactNode;
  noPadding?: boolean;
  width?: string | number;
  fullscreen?: boolean;
  variant?: 'regular' | 'small';
}

const Modal = ({
  children,
  noPadding = false,
  variant,
  width,
  fullscreen,
}: ModalProps) => (
  <div
    className={classNames(styles.modal, {
      [styles.noPadding]: noPadding,
      [styles.widthAuto]: width === 'auto',
      [styles.fullscreen]: fullscreen,
      [styles.small]: variant === 'small',
    })}
    style={width && width !== 'auto' ? { width } : undefined}
  >
    {children}
  </div>
);

export default Modal;
